'use client';

import type { LANG } from '@/store';
import { useRpgStore } from '@/plugins/rpg';
import { Image } from '@/components';
export const ChipInfoDrawerContent = ({
  lang
}: {
  lang: LANG;
}) => {
  const _chipInfoDrawer = useRpgStore(st => st.chipInfoDrawer);
  return <>
      <div className='flex flex-col items-center justify-center px-2'>
        <div className='relative aspect-video max-h-56 w-full overflow-hidden rounded-md md:max-h-80'>
          <Image src={`/layout/description_${_chipInfoDrawer.order}.jpg`} alt={`Position: ${_chipInfoDrawer.order}`} fill
        // objectFit='cover'
        />
        </div>
        <div>
          <p className='mt-4 text-center leading-5'>
            {_chipInfoDrawer.description[lang]}
          </p>
        </div>
      </div>
    </>;
};